import component from './labelEditable.vue'

export default component
